import { Modal, Spinner } from 'react-bootstrap';

// not allow for number fields
export const blockInvalidChar = e => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
// not allow for amount fields
export const blockInvalidAmount = e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
export const blockInvalidAmountWithNegative = e => ['e', 'E', '+'].includes(e.key) && e.preventDefault();
// restrict percent field
export const blockInvalidPercent = e => {

    if (e.target.value > 100) {
        e.target.value = 100;
        e.preventDefault();
        // handleInputChange(e);
    }
}

export const SpinnerModal = (props) => {
    return (
        <>
            <Modal {...props} backdrop="static" variant="info" size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <Spinner variant="info" /> Loading...
                </Modal.Body>
            </Modal>

        </>
    );
}

export const generateYears = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push(year);
    }
    return years;

}
export const getFiscalYear = (year, month) => {
    const fiscalMonths = ["JANUARY", "FEBRAURY", "MARCH", "APRIL", "MAY", "JUNE"];
    let fiscalYear = year;
    if (fiscalMonths.includes(month)) {
        fiscalYear = year - 1;
    }
    return fiscalYear
}
export const getCurrentFiscalYear = () => {
    return getFiscalYear(getCurrentYear(), getCurrentMonth());
}
export const getCurrentYear = () => {
    const currentDate = new Date();
    return currentDate.getFullYear();
}

export const getCurrentMonth = () => {
    const monthNames = [
        "JANUARY", "FEBRAURY", "MARCH", "APRIL", "MAY", "JUNE",
        "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
    ];

    const currentDate = new Date();
    return monthNames[currentDate.getMonth()];
}

export const formatCurrency = (number) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(number);
};